import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useBasketHintSection} from '../hooks/useGetBasketPageSection';
import {BasketHintSectionView} from './BasketHintSectionView';

export const BasketHintSection: React.FC = () => {
  return (
    <DataFetcher
      request={useBasketHintSection()}
      Error={null}
      View={BasketHintSectionView}
    />
  );
};
